import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { InvitePage } from "./pages/InvitePage";
import { ReviewPage } from "./pages/ReviewPage";
import { PostLoginPage } from "./pages/PostLoginPage";
import { DiscoveryChat } from "./pages/DiscoveryChat";
import { AppShell } from "./components/AppShell";
import { PersonaHome } from "./pages/home/PersonaHome";
import { RoadmapInbox } from "./pages/workspace/RoadmapInbox";
import { Dashboard } from "./pages/workspace/Dashboard";
import { PlaysIndex } from "./pages/workspace/PlaysIndex";
import { PlayWorkspace } from "./pages/workspace/PlayWorkspace";
import GamePlansIndex from "./pages/workspace/GamePlansIndex";
import GamePlanDetail from "./pages/workspace/GamePlanDetail";
import { HandsOps } from "./pages/workspace/HandsOps";
import { AgentManagement } from "./pages/workspace/AgentManagement";
import { TemplatesCatalog } from "./pages/workspace/TemplatesCatalog";
import { Planner } from "./pages/workspace/Planner";
import { Outcomes } from "./pages/workspace/Outcomes";
import { Members } from "./pages/workspace/Members";
import { Subscription } from "./pages/workspace/Subscription";
import { Settings } from "./pages/workspace/Settings";
import { HandsLibrary } from "./pages/workspace/HandsLibrary";
import { HandsDraftsList, HandsBuilder } from "./pages/workspace/HandsBuilder";
import { HandsMyHands } from "./pages/workspace/HandsMyHands";
import { TaskReviewPage } from "./pages/workspace/TaskReviewPage";
import { Spotted } from "./pages/workspace/Spotted";
import { SpotDetail } from "./pages/workspace/SpotDetail";
import { MySpotted } from "./pages/MySpotted";
import { ExternalIntakePage } from "./pages/ExternalIntake";
import { AdminTenants } from "./pages/admin/AdminTenants";
import { AdminTenantDetail } from "./pages/admin/AdminTenantDetail";
import { AdminInvitationCodes } from "./pages/admin/AdminInvitationCodes";
import { AdminAudit } from "./pages/admin/AdminAudit";
import { AdminAccessRequests } from "./pages/admin/AdminAccessRequests";
import { RequestAccessPage } from "./pages/RequestAccess";

export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/post-login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/post-login", element: <PostLoginPage /> },
  { path: "/invites/:token", element: <InvitePage /> },
  { path: "/r/:token", element: <ReviewPage /> },
  { path: "/me/spotted", element: <MySpotted /> },
  { path: "/intake/:token", element: <ExternalIntakePage /> },
  { path: "/admin", element: <Navigate to="/admin/tenants" replace /> },
  { path: "/admin/tenants", element: <AdminTenants /> },
  { path: "/admin/tenants/:tenantId", element: <AdminTenantDetail /> },
  { path: "/admin/invitation-codes", element: <AdminInvitationCodes /> },
  { path: "/admin/access-requests", element: <AdminAccessRequests /> },
  { path: "/admin/audit", element: <AdminAudit /> },
  { path: "/request-access", element: <RequestAccessPage /> },
  { path: "/discovery/:sessionId", element: <DiscoveryChat /> },
  {
    path: "/workspaces/:workspaceId",
    element: <AppShell />,
    children: [
      { index: true, element: <PersonaHome /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "plays", element: <PlaysIndex /> },
      { path: "plays/:playId", element: <PlayWorkspace /> },
      { path: "gameplans", element: <GamePlansIndex /> },
      { path: "gameplans/:campaignId", element: <GamePlanDetail /> },
      { path: "inbox", element: <RoadmapInbox /> },
      { path: "operator", element: <HandsOps /> },
      { path: "agents", element: <AgentManagement /> },
      { path: "templates", element: <TemplatesCatalog /> },
      { path: "planner", element: <Planner /> },
      { path: "discovery/:sessionId", element: <DiscoveryChat /> },
      { path: "outcomes", element: <Outcomes /> },
      { path: "people", element: <Members /> },
      { path: "subscription", element: <Subscription /> },
      { path: "settings", element: <Settings /> },
      { path: "hands/library", element: <HandsLibrary /> },
      { path: "hands/builder", element: <HandsDraftsList /> },
      { path: "hands/builder/:draftId", element: <HandsBuilder /> },
      { path: "hands/my", element: <HandsMyHands /> },
      { path: "tasks/:stepId", element: <TaskReviewPage /> },
      { path: "spotted", element: <Spotted /> },
      { path: "spotted/:spotId", element: <SpotDetail /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
